import { MomentumModalV4 } from "@circle-react-shared/ModalsV2/MomentumModalV4";
import { ActionButton } from "@circle-react-shared/ModalsV2/MomentumModalV4/ActionButton";
import { ShareNotice } from "@circle-react-shared/ModalsV2/MomentumModalV4/ShareNotice";

import { t } from "@/i18n-js/instance";

interface PostMomentumModalV4Props {
  isLoading: boolean;
  isOpen: boolean;
  onClose: () => void;
  onShareViaBroadcast: () => void;
  spaceName: string;
}

export const PostMomentumModalV4 = ({
  isOpen,
  isLoading,
  spaceName,
  onClose,
  onShareViaBroadcast,
}: PostMomentumModalV4Props) => (
  <MomentumModalV4
    isOpen={isOpen}
    onClose={onClose}
    title={t("quick_post_v2.connection_modal.title")}
    description={t("quick_post_v2.connection_modal.description", {
      space_name: spaceName,
    })}
    isLoading={isLoading}
  >
    <ShareNotice>
      <ActionButton
        startIcon="page-edit"
        onClick={onShareViaBroadcast}
        disabled={isLoading}
        data-testid="send-announcement-button"
      >
        {t("momentum_modal.share_broadcast.review_draft")}
      </ActionButton>
    </ShareNotice>
  </MomentumModalV4>
);
